<template>
    <Breadcrumbs main="Chat" title="Chat App" />
    <div class="container-fluid">
        <div class="row">
            <searchChat />
            <Card8 colClass="col call-chat-body" cardbodyClass="p-0">
                <div class="row chat-box">
                    <chatRight />
                </div>
            </Card8>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const searchChat = defineAsyncComponent(() => import("@/components/commen/searchChat.vue"))
const Card8 = defineAsyncComponent(() => import("@/components/commen/card/cardData8.vue"))
const chatRight = defineAsyncComponent(() => import("@/components/theme/chat/chatapp/chatRight.vue"))
</script>